<template>
  <div :class="['sidebarmenu-wrapper scrollable', getResponsiveMenuStatus ? 'sidebarmenu-mobile' : '']">
    <div
      v-for="(item, index) in menuItems"
      :key="item.id + index"
      class="nav-item d-flex flex-column main-menus"
    >
      <div :class="['nav-item-wrapper cursor-pointer d-flex justify-content-between align-items-center',
            {active: item.active},
            item.subMenu.some((el) => el.active) === true && item.menuCollapse === false ? 'active-single' : '']" @click="menuItemClicked(item)"
            v-authenticate="{ status: 'hide', method: item.authenticate, rule: item.rule }"
            v-if="item.isEnable"
      >
        <div class="nav-item-left d-flex align-items-center">
          <i
            :class="['nav-item-icon', item.menuCollapse === true || item.active ? item.iconClassActive : item.iconClass]"
          />
          <span class="nav-item-text text-color-white font-weight-bold" v-html="resource[item.text]" />
        </div>
        <div :class="['nav-item-right text-color-white cursor-pointer']" v-if="item.subMenu.length > 0">
          <i :class="['icon', item.menuCollapse === true ? 'icon-up-arrow' : 'icon-down-arrow']" />
        </div>
      </div>

      <b-collapse class="sub-menu" v-model="item.menuCollapse" v-if="item.subMenu.length > 0">
        <div v-for="(sub, subIndex) in item.subMenu" :key="sub.id + subIndex">
          <!-- applicantlist a -->

          <!-- nonAuthorizedPermissions-->

          <!-- ApplicantListView HRVenue ! -->

          <!-- isCompanyAdvanceOrPro ! -->

          <!-- hrvenue ! -->
          <router-link
              :class="['nav-item-wrapper align-items-center text-color-white d-flex position-relative',{active: sub.active}]"
              @click.native="subMenuItemClicked({...sub, parentMenu: item.text})"
              v-authenticate="{ status: 'hide', method: sub.authenticate }"
              :id="sub.id"
              :to="{ name: sub.routeParams.name, params: { lang: $route.params.lang || '' } }"
              v-if="sub.isEnable"
          >
              <i :class="['nav-item-icon', sub.iconClass]" />
              <span class="nav-item-text md text-color-white" v-html="resource[sub.text]" />
              <span v-if="sub.new" class="new-badge"> Yeni </span>
          </router-link>
        </div>
        <hr v-if="item.menuCollapse" class="bg-color-white"/>
      </b-collapse>
    </div>

    <!-- Company Selector Dropdown -->
    <div class="company-dropdown" v-if="currentUser?.isa">
      <validate-form
        v-model="selectedCompany"
        which-component="multiselect"
        :disabled="isCompanySelectBoxDisabled"
        allow-empty
        :name="config.userList.labelText"
        :label="config.userList.label"
        :placeholder="resource['selectUserDropdownPlaceholder']"
        :options="config.userList.options"
        :loading="config.userList.loading"
        :internal-search="config.userList.internalSearch"
        :options-limit="config.userList.displayedOptionsLimit"
        :limit="config.userList.visibleResultLimit"
        :limit-text="config.userList.searchLimitText"
        :track-by="config.userList.trackBy"
        :show-no-results="showNoResult"
        :hide-selected="true"
        @search-change="((query) => {getUserList(query); searchText = query; page = 0; hasNextPage = true;})"
        @select="(selected) => changeCompany(selected)"
      >
        <div slot="afterList">
          <div v-observe-visibility="reachedEndOfList" v-if="hasNextPage" />
        </div>
        <span slot="noResult">{{ resource["label.NoResult"] }}</span>
      </validate-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import AccountService from '@/services/account';
import { jwtDecode } from 'jwt-decode';
import { convertObjectKeyValueNamesSuperAdminUsers, handleCookies } from '../../static/helpers';
import hrvenueService from '../../services/hrvenue.service';

export default {
  name: 'SideBarMenu',
  components: {},

  watch: {
    getResponsiveMenuStatus(newVal) {
      document.querySelector('body').style.overflowY = newVal ? 'hidden' : 'auto';
    },
    $route: {
      handler() {
        this.selectActiveMenuItem();
        // this.collapseNotActiveItems();
        this.setNavMenuCloseIcon(false);
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      resize: false,
      avtMenuAdd: false,
      menuItems: [],
      ResumePoolRight: false,
      page: 0,
      selectedCompany: null,
      isCompanySelectBoxDisabled: false,
      hasNextPage: true,
      showNoResult: false,
      selectedCompanyUser: null,
      config: {
        userList: {
          labelHelpText: 'UserList',
          name: 'items',
          label: 'value',
          trackBy: 'id',
          options: [],
          loading: false,
          displayedOptionsLimit: 1000,
          visibleResultLimit: 10,
          minCharLimit: 3,
          internalSearch: false,
          allowSearch: true,
          lastKeywordLength: 0,
        },
      },
      showInfoUserList: [],
    };
  },

  computed: {
    ...mapGetters(['getResponsiveMenuStatus']),
  },

  mounted() {
    // document.querySelector('.sidebarmenu-wrapper').classList.add('scrollable');
    window.addEventListener('resize', this.checkMenuStatus);
    this.checkMenuStatus();

    const items = document.querySelectorAll('.main-menus');
    items.forEach((item) => {
      const subWrapper = item.querySelector('.sub-menu');
      if (subWrapper) {
        const subMenuItem = subWrapper.querySelectorAll('.nav-item-wrapper');
        const isHide = Array.from(subMenuItem).every((sub) => sub.style.display === 'none');
        if (isHide) {
          item.classList.remove('d-flex');
          item.classList.add('d-none');
        }
      }
    });
  },
  async created() {
    this.menuItems = [
      {
        text: 'sidebar.homeView',
        iconClass: 'icon-home',
        iconClassActive: 'icon-home-fill',
        id: 'nav_home',
        meta: 'page-home',
        routeParams: {
          name: 'HomeView',
        },
        menuCollapse: false,
        subMenu: [],
        active: false,
        isEnable: true,
        gtmEvent: {
          event: 'ga4_event',
          event_name: 'menu_click',
          event_parameters: {
            label: 'home',
          },
          page_type: 'home/dashboard',
          site_type: 'interview',
        },
      },
      {
        text: 'sidebar.interviews',
        iconClass: 'icon-interview',
        iconClassActive: 'icon-interview-fill',
        id: 'nav_interviews',
        meta: 'page-video-interview',
        routeParams: {
          name: 'HrVenueView',
        },
        menuCollapse: false,
        subMenu: [],
        active: false,
        isEnable: true,
        gtmEvent: {
          event: 'ga4_event',
          event_name: 'menu_click',
          event_parameters: {
            label: 'interview',
          },
          page_type: 'home/dashboard',
          site_type: 'interview',
        },
      },
      {
        text: 'sidebar.Integrations',
        iconClass: 'icon-link',
        iconClassActive: 'icon-link',
        id: 'nav_ats_integrations',
        meta: 'page-ats-integrations',
        routeParams: {
          name: 'IntegrationsView',
        },
        menuCollapse: false,
        subMenu: [],
        active: false,
        isEnable: true,
        gtmEvent: {
          event: 'ga4_event',
          event_name: 'menu_click',
          event_parameters: {
            label: 'ats-integrations',
          },
          page_type: 'home/dashboard',
          site_type: 'interview',
        },
      },
      {
        text: 'sidebar.questionGenerator',
        iconClass: 'icon-question',
        iconClassActive: 'icon-question-fill',
        id: 'nav_question_generator',
        meta: 'page-question-generator',
        routeParams: {
          name: 'QuestionGeneratorList',
        },
        menuCollapse: false,
        subMenu: [],
        active: false,
        isEnable: true,
        gtmEvent: {
          event: 'ga4_event',
          event_name: 'menu_click',
          event_parameters: {
            label: 'question-generator',
          },
          page_type: 'home/dashboard',
          site_type: 'interview',
        },
      },
      {
        text: 'sidebar.interviewTips',
        iconClass: 'icon-light',
        iconClassActive: 'icon-light-fill',
        id: 'nav_interview_tips',
        meta: 'page-interview-tips',
        routeParams: {
          name: 'BlogListView',
        },
        menuCollapse: false,
        subMenu: [],
        active: false,
        isEnable: true,
        gtmEvent: {
          event: 'ga4_event',
          event_name: 'menu_click',
          event_parameters: {
            label: 'interview-tips',
          },
          page_type: 'home/dashboard',
          site_type: 'interview',
        },
      },
    ];
    this.selectActiveMenuItem();
    if (this.currentUser?.isa) {
      this.getUserList('');
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.checkMenuStatus);
  },
  methods: {
    checkMenuStatus() {
      if (window.innerWidth > 992 && this.getResponsiveMenuStatus) {
        this.setResponsiveMenuStatus();
      }
      if (window.innerHeight <= 740) {
        document.querySelector('.sidebarmenu-wrapper').classList.add('scrollable');
      } else {
        document.querySelector('.sidebarmenu-wrapper').classList.remove('scrollable');
      }
    },
    selectActiveMenuItem() {
      this.menuItems.forEach((menu) => {
        menu.active = false;
        if (this.$route.name === menu.routeParams.name) {
          menu.active = true;
        }
        menu.subMenu.forEach((sub) => {
          sub.active = false;
          if (this.$route.name === sub.routeParams.name) {
            menu.menuCollapse = true;
            sub.active = true;
          }
        });
      });
    },
    setMenuItemStatus() {
      this.menuItems.forEach((menu) => {
        menu.active = false;
        menu.subMenu.forEach((sub) => {
          sub.active = false;
        });
      });
    },
    collapseNotActiveItems() {
      this.menuItems.forEach((menu) => {
        if (!menu.subMenu.some((el) => el.active)) {
          menu.menuCollapse = false;
        }
      });
    },
    menuItemClicked(item) {
      if (item.routeParams.name === 'ReportView') {
        this.setNavMenuCloseIcon(false);
        this.setResponsiveMenuStatus(false);
      }
      if (item.routeParams.name === 'BlogListView') {
        dataLayer.push(item.gtmEvent);
        window.open('https://interview.co/blog', '_blank');
        return;
      }
      if (item.subMenu.length > 0) {
        item.menuCollapse = !item.menuCollapse;
      } else {
        item.active = true;
        dataLayer.push(item.gtmEvent);
        const currentLang = this.$route.params.lang || 'en';
        this.$router.push({ name: item.routeParams.name, params: { lang: currentLang } }).catch(() => {});
        this.setNavMenuCloseIcon(false);
        this.setResponsiveMenuStatus(false);
      }
      // this.menuItems.forEach((menu) => {
      //   if (menu.id !== item.id) menu.menuCollapse = false;
      // });
    },
    subMenuItemClicked(clicked) {
      this.setNavMenuCloseIcon(false);
      // this.setMenuItemStatus();
      clicked.active = true;
      this.setResponsiveMenuStatus(false);
      // dataLayer.push({
      //   event: 'gaEvent',
      //   Category: 'menu_click',
      //   Action: this.resource[clicked.parentMenu],
      //   Label: this.resource[clicked.text],
      // });
    },
    ...mapMutations(['setResponsiveMenuStatus', 'setNavMenuCloseIcon']),

    async getUserList(query) {
      this.showNoResult = true;
      this.config.userList.loading = true;
      this.config.userList.options = [];
      this.showInfoUserList = [];

      // API REQUEST: Get users data
      try {
        const response = await hrvenueService.getSwitchUserList(query, 0, 50);
        this.config.userList.loading = false;

        if (response.items) {
          this.showInfoUserList = response.items;
          this.config.userList.options = convertObjectKeyValueNamesSuperAdminUsers(
            response,
            'items',
            'id',
            'organizerCompanyId',
            'companyName',
            'email',
            this.config.userList.trackBy,
            this.config.userList.label,
          );
          if (!response.hasNextPage) {
            this.hasNextPage = response.hasNextPage;
          }
          if (
            response.items.length === 0
            && query.length >= this.config.userList.minCharLimit
          ) {
            this.config.userList.allowSearch = false;
            this.config.userList.lastKeywordLength = query.length;
          } else {
            this.config.userList.allowSearch = true;
          }

          this.selectedCompanyUser = JSON.parse(localStorage.getItem('selectedCompanyUser'));
          const token = handleCookies.getCookie('hrvenue_identity');
          const decoded = jwtDecode(token);
          const isEqual = decoded['2E677C3FEEBEAE08B192C21D54785779D282E13E88B19FCA'] === decoded['8740759826996060'];

          if (!isEqual && this.selectedCompanyUser) {
            this.selectedCompany = this.config.userList.options.find((user) => user.id === this.selectedCompanyUser?.id) || this.selectedCompanyUser;
          }
        }
      } catch (error) {
        //
      } finally {
        this.openAILoading = false;
      }
    },
    reachedEndOfList(reached) {
      if (reached) {
        this.page += 1;
        this.getMoreUsers();
      }
    },

    async getMoreUsers() {
      this.config.userList.loading = true;
      try {
        const request = {
          pageIndex: this.page,
          searchText: this.searchText || '',
          limit: 50,
        };

        const response = await hrvenueService.getSwitchUserList(
          request.searchText,
          request.pageIndex,
          request.limit,
        );
        if (response.items) {
          this.showInfoUserList.push(...response.items);
          const convertedOptions = convertObjectKeyValueNamesSuperAdminUsers(
            response,
            'items',
            'id',
            'organizerCompanyId',
            'companyName',
            'email',
            this.config.userList.trackBy,
            this.config.userList.label,
          );
          this.config.userList.options.push(...convertedOptions);
          if (!response.hasNextPage) {
            this.hasNextPage = response.hasNextPage;
          }
          if (
            response.items.length === 0
            && request.searchText.length >= this.config.userList.minCharLimit
          ) {
            this.config.userList.allowSearch = false;
            this.config.userList.lastKeywordLength = request.searchText.length;
          } else {
            this.config.userList.allowSearch = true;
          }
        }
      } catch (error) {
        //
      } finally {
        this.config.userList.loading = false;
      }
    },
    async changeCompany(selected) {
      this.isCompanySelectBoxDisabled = true;
      await hrvenueService.setSwitchUser(1, selected?.id).then((response) => {
        this.isCompanySelectBoxDisabled = false;
        if (response.token) {
          AccountService.setToken(response.token);
          const decoded = jwtDecode(response.token);
          const isEqual = decoded['2E677C3FEEBEAE08B192C21D54785779D282E13E88B19FCA'] === decoded['8740759826996060'];
          if (!isEqual) {
            localStorage.setItem('selectedCompanyUser', JSON.stringify(selected));
            localStorage.setItem('showInfo', JSON.stringify(this.showInfoUserList.find((user) => user.id === selected?.id)));
          } else {
            localStorage.removeItem('selectedCompanyUser');
            localStorage.removeItem('showInfo');
          }

          window?.location?.reload();
        }
      }).catch(() => {
        this.isCompanySelectBoxDisabled = false;
      });
    },
  },
};
</script>

<style lang="scss">
@import "~@/style/design-kit/_variable.scss";
.sidebarmenu-wrapper {
  height: 100%;
  margin-top: -3px;
  &.scrollable {
    max-height: calc(100vh - 120px);
    @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
      max-height: calc(100vh - 40px);
    }
    overflow-y: scroll;
    overflow-x: hidden;
    .main-menus {
      padding-right: 3px !important;
    }
    &::-webkit-scrollbar {
      width: 6px !important;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-track-piece:end {
      // margin-bottom: 300px;
    }
    &::-webkit-scrollbar-track-piece:end {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #66118E;
      height: 30%;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
      margin-top: 10px;
    }
}
  @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
    height: 0;
    // transition: height ease .2s;
    overflow: hidden;
    position: fixed;
    width: 100%;
    top: 50px;
    background-color: #353535 !important;
  }
  &.sidebarmenu-mobile {
    position: fixed;
    height: 100%;
    transition: height ease .2s;
    top: 47px;
    margin-top: 0 !important;
    width: 100%;
    background-color: #353535 !important;
  }
}
.sidebarnew {
  .nav-item {
    box-shadow: none !important;
    background-color: transparent !important;
    margin-bottom: 0 !important;
    padding: 2px 8px;
    .nav-item-wrapper {
      position: relative;
      margin-top: 4px;
      padding: 8px;
      border:1px solid transparent;

      img {
        margin-right: 0.5rem;
      }

      span {
        font-family: Roboto, sans-serif;
        font-size: 0.875rem;
        line-height: 1.25rem;
      }
      .icon-up-arrow {
        opacity: 0.8;
      }
      &:not(.active-single):not(.notHover):not(.active){
        &:hover {
            // aktif menü kapattık hover yok, pasif menü ana başlık üstüne geldik hover var
            border-radius: 0.5rem;
            background: $transparent-colors-nav-hover-bg;
            color: $white !important;

            span,
            i {
              color: $white !important;
            }
            .nav-item-text {
              opacity: 1;
            }
        }
      }
      &.active-single {
        .nav-item-right {
            &::after {
              content: "";
              width: 45px;
              height: 38px;
              border: 1px solid;
              position: absolute;
              right: -8px;
              bottom: -1px;
              border-top-left-radius: 8px;
              border-bottom-left-radius: 8px;
              border-right: 0;
              border-radius: 0.5rem;
              border: 1px solid #858585;
              background: rgba(228, 228, 228, 0.10);
              color: $orange-primary !important;
              z-index: -1;
            }
        }
      }
      .nav-item-right {
        margin-right: 5px;
        margin-top: 5px;
      }
      &.active {
          &::after {
            content: "";
            position: absolute;
            border-radius: 0.5rem;
            border: 1px solid #858585;
            background: rgba(228, 228, 228, 0.10);
            color: $orange-primary !important;
            width: 100%;
            height: 100%;
            z-index: -1;
            left: 0;
          }

          span,
          i {
            color: $orange-primary !important;
          }
      }
      .new-badge {
        position: absolute;
        right: 8px;
        border: 1px solid rgba(195, 230, 203, 1);
        border-radius: 2px;
        background-color: rgba(212, 237, 218, 1);
        color: rgba(25, 91, 40, 1);
        font-size: 12px;
        height: 20px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
      }
    }
    &-icon{
      margin: 0 10px 0 8px;
      font-size: 24px !important;
      color:#F4F4F4;
      &--assesment {
        font-size: 14px !important;
      }
    }
    &-wrapper {
      min-height: 38px;
    }
    .sub-menu {
      hr {
        opacity: 0.2;
        margin: 13px 11px;
        width: auto;
      }
      .nav-item-wrapper {
        .nav-item-icon, .nav-item-text {
          opacity: 0.8;
        }
        &.active {
          .nav-item-icon, .nav-item-text {
            opacity: 1;
          }
        }
      }
    }
  }
}
.company-dropdown {
  padding: 16px;
  background: #353535;
  border-radius: 4px;
  margin-top: 16px;

  .multiselect__tags {
    padding-left: 8px !important;
    display: flex;
    align-items: center;
  }

  .multiselect__select:before {
    content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.25488 9.51094L9.41321 11.6693C9.73821 11.9943 10.2632 11.9943 10.5882 11.6693L12.7465 9.51094C13.2715 8.98594 12.8965 8.08594 12.1549 8.08594H7.83821C7.09654 8.08594 6.72988 8.98594 7.25488 9.51094Z" fill="%23333333"/></svg>') !important;
    border: none !important;
    top: 20% !important;
  }

  .multiselect__content-wrapper {
    z-index: 999;
    top: 46px !important;
    padding: 4px 0;
    border-radius: 4px !important;
    border: 1px solid #E5E5E5;
    box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12);
    width: 500px !important;
  }

}
</style>
